<template>
  <div>
    <h3 class="c-orange pb-15 fs-24">1. Revisão dos termos</h3>
    <b-form-checkbox
      id="termoConfirmacao"
      name="termoConfirmacao"
      v-model="acceptedTermsAndConditions"
      required
    >
      Li e aceito os termos e condições.
      <span class="c-orange c-pointer" v-b-modal="'termos'">Ver termos</span>
    </b-form-checkbox>
    <b-form-checkbox
      id="politicaPrivacidade"
      name="politicaPrivacidade"
      v-model="acceptedPrivacyPolicy"
      required
    >
      Li e aceito a política de privacidade.
      <span class="c-orange c-pointer" v-b-modal="'politicaPrivacidade'"
        >Ver termos</span
      >
    </b-form-checkbox>
    <TermsAndConditions />
    <PrivacyPolicy />
  </div>
</template>
<script>
import TermsAndConditions from '../../../components/TermsAndConditions.vue';
import PrivacyPolicy from '../../../components/PrivacyPolicy.vue';

export default {
  name: 'AcceptTerms',
  components: {
    TermsAndConditions,
    PrivacyPolicy,
  },
  data() {
    return {
      acceptedPrivacyPolicy: false,
      acceptedTermsAndConditions: false,
    };
  },
  methods: {
    validate() {
      let isValid = true;

      if (!this.acceptedPrivacyPolicy) {
        isValid = false;
      }

      if (!this.acceptedTermsAndConditions) {
        isValid = false;
      }

      return isValid;
    },
  },
};
</script>
